// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"804b6a3c","356":"a7d1f42a"}[chunkId] + ".chunk.css";
};